import ReCAPTCHA from "react-google-recaptcha";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? "";

interface RecaptchaFieldProps {
    onChange: (token: string) => void; // "" when the token expired
    resetKey?: number; // Changing it remounts the widget with a fresh challenge
}

const RecaptchaField = ({ onChange, resetKey = 0 }: RecaptchaFieldProps) => {
    return (
        <ReCAPTCHA
            key={resetKey}
            sitekey={SITE_KEY}
            onChange={(token) => onChange(token ?? "")}
            onExpired={() => onChange("")} // An expired token can no longer be submitted
        />
    );
};

export default RecaptchaField;